import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Typography,
  Divider,
  Spin,
  Row,
  Col,
  Select,
  Card,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import PageRoutes from "../../utils/routes";
import useAuthService from "../../services/useAuthService";
import useCommonsService from "../../services/useCommonsService";

const { Option } = Select;

const SignUpFirm = () => {
  const [form] = useForm();
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const { firmRegister, isFirmRegisterLoading } = useAuthService();
  const { cities, isLoadingCities, useDistricts } = useCommonsService();

  // Get districts based on selected city
  const { data: districts, isLoading: isLoadingDistricts } =
    useDistricts(selectedCityId);

  const handleCityChange = (value) => {
    setSelectedCityId(value);
    form.setFieldValue("district", undefined);
  };

  const onSubmit = async (values) => {
    const requestBody = {
      ...values,
    };
    console.log(values);
  };

  return (
    <>
      <Card
        style={{
          maxWidth: 750,
          margin: "40px auto", // Added marginTop
          padding: "24px",
          boxShadow: "0px 5px 15px hsla(220, 30%, 5%, 0.05)",
        }}>
        <Typography.Title level={2} style={{ textAlign: "center" }}>
          Firma Kayıt Ol
        </Typography.Title>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Divider orientation="left"> Şirket Bilgileri</Divider>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Şirket Adı"
                name="companyName"
                rules={[
                  { required: true, message: "Lütfen şirket adını giriniz" },
                ]}>
                <Input placeholder="Şirket Adı" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="VKN"
                name="taxNo"
                rules={[
                  {
                    required: true,
                    message: "Lütfen VKN numaranızı giriniz",
                  },
                  {
                    len: 10,
                    message: "VKN numarası 10 haneli olmalıdır",
                  },
                ]}>
                <Input placeholder="VKN" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Şehir"
                name="city" // Changed from district to city
                rules={[
                  {
                    required: true,
                    message: "Lütfen Şehir seçiniz",
                  },
                ]}>
                <Select
                  loading={isLoadingCities}
                  options={cities}
                  placeholder="Şehir"
                  onChange={handleCityChange}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="İlçe"
                name="district"
                rules={[
                  {
                    required: true,
                    message: "Lütfen İlçe seçiniz",
                  },
                ]}>
                <Select
                  loading={isLoadingDistricts}
                  options={districts}
                  placeholder="İlçe"
                  disabled={!selectedCityId}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Vergi Dairesi "
                name="taxOffice"
                rules={[
                  { required: true, message: "Lütfen vergi dairesi giriniz" },
                ]}>
                <Input placeholder="Vergi Dairesi" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Açık Adres "
                name="address"
                rules={[
                  { required: true, message: "Lütfen açık adres giriniz" },
                ]}>
                <Input placeholder="Adres Tanımı" />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left"> Kullanıcı Bilgileri</Divider>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Ad"
                name="firstName"
                rules={[{ required: true, message: "Lütfen adınızı giriniz" }]}>
                <Input placeholder="Ad" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Soyad"
                name="lastName"
                rules={[
                  { required: true, message: "Lütfen soyadınızı giriniz" },
                ]}>
                <Input placeholder="Soyad" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Telefon"
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Lütfen telefon numaranızı giriniz",
                  },
                ]}>
                <Input maxLength={10} prefix="+90" placeholder="Telefon" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="E-posta"
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Lütfen geçerli bir e-posta giriniz",
                  },
                ]}>
                <Input placeholder="E-posta" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Şifre"
                name="password"
                rules={[
                  { required: true, message: "Lütfen şifrenizi giriniz" },
                ]}>
                <Input.Password placeholder="Şifre" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Şifrenizi Tekrar Giriniz"
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Lütfen şifrenizi tekrar giriniz",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Şifreler eşleşmiyor"));
                    },
                  }),
                ]}>
                <Input.Password placeholder="Şifrenizi Tekrar Giriniz" />
              </Form.Item>
            </Col>
          </Row>

          <Button
            style={{ marginTop: 25 }}
            type="primary"
            htmlType="submit"
            block>
            Kayıt Ol
          </Button>
        </Form>

        <Divider>veya</Divider>

        <Typography.Text style={{ display: "block", textAlign: "center" }}>
          Zaten bir hesabınız var mı?{" "}
          <Button type="link" onClick={() => navigate(PageRoutes.loginFirm)}>
            Giriş yapın
          </Button>
        </Typography.Text>
      </Card>

      <Spin spinning={isLoading} />
      <ModalComponent />
    </>
  );
};

export default SignUpFirm;
